// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vyq9Q","label":"styles_label__3e29B"};